















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Document } from '@/model/document2/document';
import { InsertionData } from '@/model/document2/insertionData/insertionData';

import * as def from "@/definitions";

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";

@Component({
  components: {
    DropdownList,
    ArrowDown,
    ArrowRight
  }
})
export default class InputController extends Vue 
{
    @Prop() private document!: Document;

    private get text()
    {
        var row = this.document.selectedInsertionRow;
        var col = this.document.selectedInsertionColumn;
        var cell = this.document.insertionData.getCellData(row, col);
        return cell != null ? cell.content : "";
    }

    private set text(text)
    {
        // setterのタイミングでは変更しない
    }

    private changeText()
    {
        // テキスト確定
        var row = this.document.selectedInsertionRow;
        var col = this.document.selectedInsertionColumn;
        var textarea = this.$refs.textarea as HTMLTextAreaElement;
        this.$emit("doCommand", "changeCellText", {text : textarea.value, row : row, column : col});
    }

    private importImage()
    {
        // ローカルイメージパスの読み込み
        this.$emit("doCommand", "importLocalImagePath", null);
    }

    //-----configcolor-----//
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
    //-----configcolor-----//
}
